import React from 'react';
import { PaymentsForm } from '../../../components/PaymentsForm';
export const PaymentsComponent = (props: any) => <PaymentsForm {...props} />;
